/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commercial BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2023-01-27 14:21:40
 *
 *******************************************************/
// @flow

import _ from 'lodash';
import React, { Component } from 'react';
import { FormLayout, TextStyle, Link, Icon } from '@shopify/polaris';
import { ExternalMinor } from '@shopify/polaris-icons';
import { withI18n, WithI18nProps } from '@shopify/react-i18n';
import { Field } from 'redux-form';
// import { RenderSelect2 } from 'src/components/views/common/forms/render-select-2-v2';
import { RenderCheckbox } from 'src/components/views/common/forms/render-checkbox';
import { RenderRadioButton2 } from 'src/components/views/common/forms/render-radio-button-2';
import { URL } from 'src/constants/links';

import { ELEMENT_KEY_NAME } from 'src/constants/theme-settings';
import { MENU_ID, LABEL_SHAPE_OPTIONS } from 'src/constants/theme-settings.jsx';
// import { DropdownIndicator, styles } from './react-select-style';

type Props = {
  formValues: any,
  prefix: string,
  updateField: (field: string, value: any) => void
};

type ComposedProps = Props & WithI18nProps;

class ProductItemLabelForm extends Component<ComposedProps> {
  state = {
    error: ''
  };

  componentWillReceiveProps(nextProps) {
    const { formValues } = this.props;
    const { formValues: nextFormValues, updateField } = nextProps;
    const saleLabelKey = Object.keys(_.get(formValues, 'setting', {})).find(key =>
      key.toLowerCase().includes(ELEMENT_KEY_NAME.SALE_LABEL.toLowerCase())
    );
    const soldOutLabelKey = Object.keys(_.get(formValues, 'setting', {})).find(key =>
      key.toLowerCase().includes(ELEMENT_KEY_NAME.SOLD_OUT_LABEL.toLowerCase())
    );
    const customByTagLabelKey = Object.keys(_.get(formValues, 'setting', {})).find(key =>
      key.toLowerCase().includes(ELEMENT_KEY_NAME.CUSTOM_BY_TAG_LABEL.toLowerCase())
    );

    // Sale label isEnable
    const isShowSaleLabel = _.get(formValues, `setting.${MENU_ID.PRODUCT_LABEL}.showSaleLabel`);
    const nextIsShowSaleLabel = _.get(
      nextFormValues,
      `setting.${MENU_ID.PRODUCT_LABEL}.showSaleLabel`
    );
    if (isShowSaleLabel !== nextIsShowSaleLabel) {
      updateField(`setting.${saleLabelKey}.isEnable`, nextIsShowSaleLabel);
    }

    // Sold out label isEnable
    const isShowSoldOutLabel = _.get(
      formValues,
      `setting.${MENU_ID.PRODUCT_LABEL}.showSoldOutLabel`
    );
    const nextIsShowSoldOutLabel = _.get(
      nextFormValues,
      `setting.${MENU_ID.PRODUCT_LABEL}.showSoldOutLabel`
    );
    if (isShowSoldOutLabel !== nextIsShowSoldOutLabel) {
      updateField(`setting.${soldOutLabelKey}.isEnable`, nextIsShowSoldOutLabel);
    }

    // Custom by tag label isEnable
    const isShowCustomByTagLabel = _.get(
      formValues,
      `setting.${MENU_ID.PRODUCT_LABEL}.showCustomByTagLabel`
    );
    const nextIsShowCustomByTagLabel = _.get(
      nextFormValues,
      `setting.${MENU_ID.PRODUCT_LABEL}.showCustomByTagLabel`
    );
    if (isShowCustomByTagLabel !== nextIsShowCustomByTagLabel) {
      updateField(`setting.${customByTagLabelKey}.isEnable`, nextIsShowCustomByTagLabel);
    }

    // Label shape
    const shape = _.get(formValues, `setting.${MENU_ID.PRODUCT_LABEL}.shape`);
    const nextShape = _.get(nextFormValues, `setting.${MENU_ID.PRODUCT_LABEL}.shape`);
    if (shape !== nextShape) {
      updateField(`setting.${saleLabelKey}.shape`, nextShape);
      updateField(`setting.${soldOutLabelKey}.shape`, nextShape);
      updateField(`setting.${customByTagLabelKey}.shape`, nextShape);
    }
  }

  render() {
    const {
      i18n
      // prefix
      //  formValues, labelTranslation, updateField
    } = this.props;

    const formattedLabelShape = LABEL_SHAPE_OPTIONS.map(item => ({
      tooltip: i18n.translate(item.tooltip),
      value: item.value,
      icon: item.icon
    }));

    // const formattedLabelDisplay = LABEL_DISPLAY_OPTIONS.map(item => ({
    //   label: i18n.translate(item.label),
    //   value: item.value
    // }));

    return (
      <FormLayout>
        <div>
          <span className="form-link">
            <TextStyle variation="subdued">
              {i18n.translate('AdminHTML.ShopifyIntegrationSettings.Form.productLabel_UserGuide')}
            </TextStyle>{' '}
            <Link url={URL['SaleLabelThemeSetting']} external>
              {i18n.translate('AdminHTML.ThemeSetting.Common.clickHere')}
              <Icon source={ExternalMinor} color="base" />
            </Link>
            <span style={{ color: '#2C6ECB' }}>.</span>
          </span>
        </div>

        <div className="form-section">
          <div className="form-section__item">
            <Field
              name={`setting.${MENU_ID.PRODUCT_LABEL}.showSaleLabel`}
              component={RenderCheckbox}
              label={i18n.translate(
                'AdminHTML.ShopifyIntegrationSettings.Form.productLabel_ShowSaleLabel'
              )}
            />
          </div>

          <div className="form-section__item form-section__item--medium-spacing">
            <Field
              name={`setting.${MENU_ID.PRODUCT_LABEL}.showSoldOutLabel`}
              component={RenderCheckbox}
              label={i18n.translate(
                'AdminHTML.ShopifyIntegrationSettings.Form.productLabel_ShowSoldOutLabel'
              )}
            />
          </div>

          <div className="form-section__item form-section__item--medium-spacing">
            <Field
              name={`setting.${MENU_ID.PRODUCT_LABEL}.showCustomByTagLabel`}
              component={RenderCheckbox}
              label={i18n.translate(
                'AdminHTML.ShopifyIntegrationSettings.Form.productLabel_ShowCustomByTagLabel'
              )}
            />
          </div>

          {/* Label display */}
          {/* <div className="form-section__item form-section__item--medium-spacing">
            <Field
              name={`setting.${MENU_ID.PRODUCT_LABEL}.displayOptions`}
              label={i18n.translate(
                'AdminHTML.ShopifyIntegrationSettings.Form.productLabel_DisplayOption_Title'
              )}
              options={formattedLabelDisplay}
              component={RenderSelect2}
              components={{ DropdownIndicator }}
              styles={styles}
              isSearchable={false}
            />
          </div> */}

          {/* Label shape */}
          <div className="form-section__item form-section__item--medium-spacing">
            <p className="title" style={{ marginBottom: '8px' }}>
              {i18n.translate('AdminHTML.ThemeSetting.Form.saleLabel_Shape_Item')}
            </p>
            <div className="radio-button-wrapper radio-button-wrapper--outline">
              {formattedLabelShape.map((item, index) => (
                <Field
                  key={index}
                  name={`setting.${MENU_ID.PRODUCT_LABEL}.shape`}
                  id={item.value}
                  component={RenderRadioButton2}
                  label={item.icon}
                  tooltip={item.tooltip}
                  isShowIconCheck
                />
              ))}
            </div>
          </div>
        </div>
      </FormLayout>
    );
  }
}

export default withI18n()(ProductItemLabelForm);
